import { env as runtimeEnv } from 'next-runtime-env';

const env = (key: string) => runtimeEnv(key) as string;

export const SETTINGS = {
  public: {
    tmsToken: env('NEXT_PUBLIC_TMS_TOKEN'),
    urlAccountSvc: env('NEXT_PUBLIC_URL_ACCOUNT_SVC'),
    urlContractLegacyWeb: env('NEXT_PUBLIC_URL_CONTRACT_LEGACY_WEB'),
    urlContractLegacySvc: env('NEXT_PUBLIC_URL_CONTRACT_LEGACY_SVC'),
    urlPlanWeb: env('NEXT_PUBLIC_URL_PLAN_WEB'),
    urlClubePublicationWeb: env('NEXT_PUBLIC_URL_CLUBE_PUBLICATION_WEB'),
    urlClubeAdminWeb: env('NEXT_PUBLIC_URL_CLUBE_ADMIN_WEB'),
    urlClubePartnerWeb: env('NEXT_PUBLIC_URL_CLUBE_PARTNER_WEB'),
    urlClubeParcerias: env('NEXT_PUBLIC_URL_CLUBE_PARCERIAS'),
    urlMedicationsWeb: env('NEXT_PUBLIC_URL_MEDICATIONS_WEB'),
    urlMedicalPartnerWeb: env('NEXT_PUBLIC_URL_MEDICAL_PARTNER_WEB'),
    urlPosthumousWeb: env('NEXT_PUBLIC_URL_POSTHUMOUS_WEB'),
    urlMedicalPartnerWeb: env('NEXT_PUBLIC_URL_MEDICAL_PARTNER_WEB'),
    urlAccountWeb: env('NEXT_PUBLIC_URL_ACCOUNT_WEB'),
    urlAuthWeb: env('NEXT_PUBLIC_URL_AUTH_WEB'),
    urlHubWeb: env('NEXT_PUBLIC_URL_HUB_WEB'),
    urlBillingWeb: env('NEXT_PUBLIC_URL_BILLING_WEB'),
    urlOrderWeb: env('NEXT_PUBLIC_URL_ORDER_WEB'),
    urlSaleWeb: env('NEXT_PUBLIC_URL_SALE_WEB'),
    urlRoleWeb: env('NEXT_PUBLIC_URL_ROLE_WEB'),
    urlChatWeb: env('NEXT_PUBLIC_URL_CHAT_WEB'),
    urlRoleSvc: env('NEXT_PUBLIC_URL_ROLE_SVC'),
    urlTelevetWeb: env('NEXT_PUBLIC_URL_TELEVET_WEB'),
    urlTeleconsultationWeb: env('NEXT_PUBLIC_URL_TELECONSULTATION_WEB'),
    urlOrthopedicSupportWeb: env('NEXT_PUBLIC_URL_ORTHOPEDIC_SUPPORT_WEB'),
    urlProfileSvc: env('NEXT_PUBLIC_URL_PROFILE_SVC'),
    urlProfileWeb: env('NEXT_PUBLIC_URL_PROFILE_WEB'),
    urlTermWeb: env('NEXT_PUBLIC_URL_TERM_WEB'),
    basePath: env('NEXT_PUBLIC_BASE_PATH'),
  },
  server: {
    basePath: env('BASE_PATH'),
    maintenance: env('MAINTENANCE_ENABLED'),
  },
};
